<script lang="ts">
  import type { GithubButton, GithubButtons } from '$lib/sanity/schemas/components/GithubButtons';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import { onMount } from 'svelte';

  interface Props {
    portableText: CustomBlockComponentProps<GithubButtons>;
  }

  let { portableText }: Props = $props();
  let starButton: GithubButton = $state();
  let forkButton: GithubButton = $state();
  let followButton: GithubButton = $state();

  if (portableText.value) {
    starButton = portableText.value.starButton;
    forkButton = portableText.value.forkButton;
    followButton = portableText.value.followButton;
  }

  onMount(() => {
    const existing = document.querySelector('script[src="https://buttons.github.io/buttons.js"]');
    if (!existing) {
      const script = document.createElement('script');
      script.src = 'https://buttons.github.io/buttons.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      if (window?.GitHubButtons?.renderAll) {
        window.GitHubButtons.renderAll();
      }
    }
  });
</script>

{#if starButton || forkButton || followButton}
  <div class="github-stats">
    {#if starButton}
      <a
        class="github-button"
        href={starButton.url}
        data-color-scheme="no-preference: light; light: light; dark: dark;"
        data-icon="octicon-star"
        data-size="large"
        data-show-count="true"
        aria-label={starButton.ariaLabel || 'Star on GitHub'}
      >
        {starButton.text || 'Star'}
      </a>
    {/if}
    {#if forkButton}
      <a
        class="github-button"
        href={forkButton.url}
        data-color-scheme="no-preference: light; light: light; dark: dark;"
        data-icon="octicon-repo-forked"
        data-size="large"
        data-show-count="true"
        aria-label={forkButton.ariaLabel || 'Fork on GitHub'}
      >
        {forkButton.text || 'Fork'}
      </a>
    {/if}
    {#if followButton}
      <a
        class="github-button"
        href={followButton.url}
        data-color-scheme="no-preference: light; light: light; dark: dark;"
        data-size="large"
        data-show-count="true"
        aria-label={followButton.ariaLabel || 'Follow on GitHub'}
      >
        {followButton.text || 'Follow'}
      </a>
    {/if}
  </div>
{/if}

<style>
  .github-stats {
    display: flex;
    gap: 16px;
    align-items: center;
  }
</style>
